import React from 'react';
import ReactDOM from 'react-dom';

import 'components/assets/sass/index.scss';

import routes from './routes/Routes';
import Root from './Root';
import { store, browserHistory } from './redux/store/configureStore';

import 'moment/locale/ru';
import moment from 'moment';

moment.locale('ru');


ReactDOM.render(
  <Root history={browserHistory} routes={routes} store={store} />,
  document.getElementById('root'),
);
